import { IconButton } from 'components/shared/IconButton';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormattedMessage, useIntl } from 'react-intl';
import { EssentialMoreMenu } from 'routes/essential-workspace/components/side-panel/header/more-menu';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { workspaceTabCreatedThunk } from 'state/workspaces/workspace.thunks';

type SidePanelHeaderProps = {
  toggleSidePanel: () => void;
};

export function Header({ toggleSidePanel }: SidePanelHeaderProps) {
  const { formatMessage } = useIntl();
  const dispatch = useThunkDispatch();

  const addNewTab = () => {
    dispatch(workspaceTabCreatedThunk('essential', 'quote', true));
    logAnalytics.trackEvent('Primary market essential', 'New quote');
  };

  return (
    <div className="offcanvas-header d-flex bg-blur bg-lvl1 bg-opacity-70 p-0 z-3">
      <div className="flex-grow-1 flex-x gap-2 p-2">
        <button
          className="btn btn-flat-secondary btn-lg btn-icon"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvas"
          aria-controls="offcanvasExample"
          aria-label={formatMessage({ id: 'essential.workspace.close.side.panel.btn.ariaLabel' })}
          onClick={toggleSidePanel}
        >
          <span className="material-symbols-rounded">thumbnail_bar</span>
        </button>
        <div className="offcanvas-heading">
          <h1 className="h4">
            <FormattedMessage id="essential.workspace.side.panel.title" />
          </h1>
        </div>
      </div>
      <div className="flex-x p-2">
        <IconButton
          iconName="add"
          className="btn-lg"
          onClick={addNewTab}
          ariaLabel={formatMessage({ id: 'essential.workspace.side.panel.add.btn.ariaLabel' })}
        />
        <EssentialMoreMenu onAddTab={addNewTab} />
      </div>
    </div>
  );
}
